<div class="field-container" class="flex flex-col gap-8">
  <p-fieldset>
    <ng-template #header >
      <div class="flex items-center gap-2 p-4 hover:cursor-pointer px-2 hover:bg-cyan-500 hover:text-white rounded-md" (click)="navigateTo('/keyphrase-extraction')">
        <i class="pi pi-file-edit" style="font-size: 2rem"></i>
        <span class="font-bold">Keyphrase Extraction</span>
      </div>
    </ng-template>
    <p class="m-6">
      This page contains candidate thematic areas, their definition and relevant
      keywords that are associated with those areas. <br> AI takes everything as
      input and outputs potential thematic areas and keywords that represent
      incoming transcriptions based on their content.
    </p>
    <!-- <p-button label="Start" class="mt-10" (onClick)="navigateTo('/keyphrase-extraction')"/> -->
  </p-fieldset>
  <p-fieldset>
    <ng-template #header >
      <div class="flex items-center gap-2 hover:cursor-pointer p-4 px-2 hover:bg-cyan-500 hover:text-white rounded-md" (click)="navigateTo('/topic-classification')">
        <i class="pi pi-file-edit" style="font-size: 2rem"></i>
        <span class="font-bold">Topic Classification</span>
      </div>
    </ng-template>
    <p class="m-6">
      This page contains candidate topics that are going to be used to classify
      nrg customer support calls. <br> AI takes topic names and their descriptions as
      input and makes the classification on incoming transcriptions.
    </p>
    <!-- <p-button label="Start" class="mt-10" (onClick)="navigateTo('/topic-classification')"/> -->
  </p-fieldset>
</div>
